import { Customer as sdkCustomer, Services as sdkServices } from "coolremote-sdk";

interface CacheEntry {
    policiesPromise: Promise<any>;
    rolesPromise: Promise<any>;
    unitsPromise: Promise<any>;
}

const cache: { [customerId: string]: CacheEntry } = {};

export const prefetchPermissions = (
    customerId: string,
    getAllCustomerUnits: (customerId: string) => Promise<any>
) => {
    if (!customerId) return;
    if (cache[customerId]) return; // Already cached/prefetching

    const policiesPromise = sdkCustomer.getCustomerPoliciesAvailable(customerId)
        .catch((err: any) => {
            delete cache[customerId];
            throw err;
        });

    const rolesPromise = sdkServices.getRoles()
        .catch((err: any) => {
            delete cache[customerId];
            throw err;
        });

    const unitsPromise = getAllCustomerUnits(customerId)
        .catch((err: any) => {
            delete cache[customerId];
            throw err;
        });

    cache[customerId] = {
        policiesPromise,
        rolesPromise,
        unitsPromise,
    };
};

export const getPermissionsData = (
    customerId: string,
    getAllCustomerUnits: (customerId: string) => Promise<any>
) => {
    if (!cache[customerId]) {
        prefetchPermissions(customerId, getAllCustomerUnits);
    }
    return cache[customerId];
};

export const clearPermissionsCache = (customerId?: string) => {
    if (customerId) {
        delete cache[customerId];
    } else {
        for (const key in cache) {
            delete cache[key];
        }
    }
};
